import type React from "react";
import styles from "./index.module.scss";

interface CustomCheckboxProps {
  label: string;
  checked?: boolean;
  onChange?: (checked: boolean) => void;
  disabled?: boolean;
}

export const CustomCheckbox: React.FC<CustomCheckboxProps> = ({
  label,
  checked = false,
  onChange,
  disabled = false,
}) => {
  return (
    <div className={styles["checkbox-wrapper"]}>
      <label>
        <input
          type="checkbox"
          className={styles["custom-checkbox"]}
          checked={checked}
          onChange={(e) => onChange?.(e.target.checked)}
          disabled={disabled}
        />
        <span>{label}</span>
      </label>
    </div>
  );
};
